//
// locales/vanilla/he.js
// automatically generated by generateLocalePacks.js
//

import messages from '../../../app/javascript/mastodon/locales/he.json';
import localeData from 'react-intl/locale-data/he.js';
import { setLocale } from 'locales';

setLocale({
  localeData,
  messages,
});
